import { render, staticRenderFns } from "./IconSvgPsd.vue?vue&type=template&id=db437b98&scoped=true&"
import script from "./IconSvgPsd.vue?vue&type=script&lang=js&"
export * from "./IconSvgPsd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db437b98",
  null
  
)

export default component.exports